import type { IconDefinition } from '../index.tsx';

export const iconEllipsisVertical: IconDefinition = {
  prefix: 'fas',
  iconName: 'iconEllipsisVertical',
  icon: [
    128,
    512,
    [],
    '',
    'M64 360a56 56 0 1 0 0 112 56 56 0 1 0 0-112zm0-160a56 56 0 1 0 0 112 56 56 0 1 0 0-112zM120 96A56 56 0 1 0 8 96a56 56 0 1 0 112 0z',
  ],
};
